import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { SettingsEffects } from './settings.effects';
import * as fromsettings from './settings.reducer';

@NgModule({ declarations: [],
    exports: [], imports: [StoreModule.forFeature(fromsettings.FEATURE_NAME, fromsettings.settingsReducer),
        EffectsModule.forFeature([SettingsEffects])], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class SettingsModule {}
